<template>
  <div>
    <div
      class="mgt-40 t-body6 font-r t-color-bodyGrayA"
      v-if="
        recentLearning &&
        recentLearning.length > 0 &&
        recentLearning[0].progressRate != 100
      "
    >
      {{ $t("3199") }}
    </div>
    <div
      class="divider mgt-8"
      v-if="
        recentLearning &&
        recentLearning.length > 0 &&
        recentLearning[0].progressRate != 100
      "
    ></div>
    <div
      class="cursor-pointer"
      @click="redirectToRecentLearnDetail(recentLearning[0].id)"
      @keypress="redirectToRecentLearnDetail(recentLearning[0].id)"
      v-if="
        recentLearning &&
        recentLearning.length > 0 &&
        recentLearning[0].progressRate != 100
      "
      tabindex="0"
    >
      <div class="mgt-24 t-body6 font-r t-color-bodyGrayA">
        {{ isSkillPath ? $t("30226") : $t("30225") }}
      </div>
      <div class="d-flex justify-content-between">
        <div class="mgt-2 t-subtitle5 font-m t-line-h-28">
          {{
            recentLearning && recentLearning.length > 0
              ? recentLearning[0].name
              : null
          }}
        </div>
        <button
          v-if="recentLearning && recentLearning.length > 0"
          class="material-icons mdc-icon-button t-color-iconInactive mgt--6 rtl-support"
        >
          keyboard_arrow_right
        </button>
      </div>
      <div class="d-flex align-items-center">
        <div class="position-relative flex-grow-1 mgr-28">
          <div class="percentage-wrapper">
            <div
              class="h-2 position-relative total-percentage bg-disableBtn h-2"
            >
              <div
                class="real-percentage bg-saleLine b-radius0 h-2 mgt-2"
                :style="{
                  width:
                    (recentLearning && recentLearning.length > 0
                      ? recentLearning[0].progressRate
                      : 0) + '%',
                }"
              ></div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-baseline mgr-100 t-nowrap">
          <div
            class="t-headline3 t-color-headlineBlack t-line-h-15 d-flex align-items-center font-b"
          >
            {{
              recentLearning && recentLearning.length > 0
                ? recentLearning[0].progressRate
                : 0
            }}
          </div>
          <div class="t-subtitle1 font-b mgl-4">%</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainDashBoardCurrentLearn",
  props: ["recentLearning", "redirectToRecentLearnDetail", "isSkillPath"],
};
</script>

<style>
</style>